import { ThemeEvents } from '@theme/events';

class CBRefillProduct extends HTMLElement {
  #section;

  connectedCallback() {
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    if (this.dataset.selectedVariant) this.#activateProfile(this.dataset.selectedVariant);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    this.#section = null;
  }

  #handleVariantUpdate = (event) => {
    const productId = event.detail.data.productId;
    if (productId && String(productId) !== this.dataset.productId) return;

    const title = event.detail.resource?.title;
    if (!title) return;

    this.#activateProfile(title);
  };

  #activateProfile(title) {
    const normalizedTitle = title.trim().toLocaleLowerCase();
    const profiles = Array.from(this.querySelectorAll('[data-refill-profile]'));
    const profile = profiles.find(
      (item) => item.dataset.variantTitle?.trim().toLocaleLowerCase() === normalizedTitle
    );

    if (!profile) return;

    for (const item of profiles) {
      const isActive = item === profile;
      item.hidden = !isActive;
      item.setAttribute('aria-hidden', String(!isActive));
    }

    this.style.setProperty('--cb-refill-accent', profile.dataset.accent || '#8065a7');
    this.style.setProperty('--cb-refill-surface', profile.dataset.surface || '#eee8f5');
    this.style.setProperty('--cb-refill-profile-text', profile.dataset.textColor || '#221348');
  }
}

if (!customElements.get('cb-refill-product')) {
  customElements.define('cb-refill-product', CBRefillProduct);
}
